module.exports = __webpack_public_path__ + "static/media/ico-support.b7a9dcd3.svg";